"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var AccordionContext = /*#__PURE__*/_react["default"].createContext({
  isOpen: false
});
var _default = AccordionContext;
exports["default"] = _default;